export default {
    table : {
        itensPagina: 'Rows per page: ',
        de: 'of'
    }
    
}